import { Box } from "@mui/material";
import _ from "lodash";
import React from "react";
import { useApiErrorModalContext } from "./ApiErrorModalContext";
import { getCustomErrorMessage } from "./CustomErrors";
import styles from "./ErrorHandlingComponent.module.scss";
import i18n from "i18next";
import CustomModalDialog from "../components/modal/CustomModalDialog";
import Button from "../components/buttons/Buttons";

export const ApiErrorModal = () => {
  const { apiErrorModalState, setApiErrorModalState } =
    useApiErrorModalContext();

  const closeModal = () => {
    setApiErrorModalState({ error: undefined });
  };
  return (
    <Box data-testid="api-error-modal">
      <CustomModalDialog
        title="Error"
        isShow={!_.isUndefined(apiErrorModalState.error)}
        isCloseButton={true}
        className={"modal-dialog"}
        hasFooter={false}
        onClose={() => closeModal(false)}
      >
        <Box
          className={styles.deleteCertificateWrapper}
          data-testid="deleteCertificate"
        >
          <Box className={styles.contentWrapper}>
            <Box className={styles.description}>
              {getCustomErrorMessage(apiErrorModalState.error)}
            </Box>
          </Box>

          <Box className={styles.buttonWrapper}>
            <Button
              title={i18n.t("OK")}
              iconStyle={""}
              buttonType="muibtn-primary"
              withIcon={false}
              handleClick={() => closeModal(false)}
            />
          </Box>
        </Box>
      </CustomModalDialog>
    </Box>
  );
};
